export interface IContent {

}

class Content implements IContent {
    // constructor() {
    // }
}

export default Content